import React, { Component } from 'react';

const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;

export class NumericSOEditor extends Component {
    constructor(props) {
        super(props);

        this.cancelBeforeStart = this.props.charPress && ('1234567890'.indexOf(this.props.charPress) < 0);

        this.state = this.createInitialState(props);

        this.onKeyDown = this.onKeyDown.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.refs.input.addEventListener('keydown', this.onKeyDown);
    }

    componentWillUnmount() {
        this.refs.input.removeEventListener('keydown', this.onKeyDown);
    }

    createInitialState(props) {
        let startValue;

        if (props.keyPress === KEY_BACKSPACE || props.keyPress === KEY_DELETE) {
            // if backspace or delete pressed, we clear the cell
            startValue = '';
        } else if (props.charPress) {
            // if a letter was pressed, we start with the letter
            startValue = props.charPress;
        } else {
            // otherwise we start with the current value
            startValue = props.value;          
        }

        return {
            value: startValue
        };
    }

    afterGuiAttached() {
        // get ref from React component
        const eInput = this.refs.input;
        eInput.focus();
        eInput.select();
    }

    getValue() {
        return this.state.value;
    }

    isCancelBeforeStart() {
        return this.cancelBeforeStart;
    }

    // will reject the number if it greater than 1,000,000
    // not very practical, but demonstrates the method.
    isCancelAfterEnd() {
        return this.state.value > 1000000;
    }

    onKeyDown(event) {
        if (this.isLeftOrRight(event) || this.deleteOrBackspace(event)) {
            event.stopPropagation();
            return;
        }

        if (event.keyCode === 38) {
            event.stopPropagation();
            // If there is a row above current focus navigate
            if (this.refs.input.parentElement.parentElement.previousElementSibling !== null) {
                // If this is an editable row then focus
                if (this.refs.input.parentElement.parentElement.previousElementSibling.lastChild.childElementCount === 1) {
                    this.refs.input.parentElement.parentElement.previousElementSibling.lastChild.lastChild.focus();
                }
                // Else if this is a locked row loop to find the next unlocked row that is not beyond the table index
                else {
                    let skipRow = this.refs.input.parentElement.parentElement.previousElementSibling.previousElementSibling;
                    let foundRow = false;
                    let beyondIndex = false;

                    while (!foundRow) {
                        if (skipRow === null) {
                            foundRow = true;
                            beyondIndex = true;
                            break;
                        }

                        if (skipRow.lastChild.childElementCount === 1) {
                            foundRow = true;
                        }
                        else {
                            skipRow = skipRow.previousElementSibling;
                        }
                    }

                    if (beyondIndex) {
                        return;
                    } else {
                        skipRow.lastChild.lastChild.focus();
                    }
                }
            }
            return;
        }

        if (event.keyCode === 40) {
            event.stopPropagation();
            // If there is a row below current focus navigate
            if (this.refs.input.parentElement.parentElement.nextElementSibling !== null) {
                // If this is an editable row then focus
                if (this.refs.input.parentElement.parentElement.nextElementSibling.lastChild.childElementCount === 1) {
                    this.refs.input.parentElement.parentElement.nextElementSibling.lastChild.lastChild.focus();
                }
                // Else if this is a locked row loop to find the next unlocked row that is not beyond the table index
                else {
                    let skipRow = this.refs.input.parentElement.parentElement.nextElementSibling.nextElementSibling;
                    let foundRow = false;
                    let beyondIndex = false;

                    while (!foundRow) {    
                        if (skipRow === null) {
                            foundRow = true;
                            beyondIndex = true;
                            break;
                        }

                        if (skipRow.lastChild.childElementCount === 1) {
                            foundRow = true;
                        }
                        else {
                            skipRow = skipRow.nextElementSibling;
                        }
                    }

                    if (beyondIndex) {
                        return;
                    } else {
                        skipRow.lastChild.lastChild.focus();
                    }
                }
            }
            return;
        }

        if (!this.isKeyPressedNumeric(event) && event.keyCode !== 9) {
            if (event.preventDefault) event.preventDefault();
        }
    }

    isLeftOrRight(event) {
        return [37, 39].indexOf(event.keyCode) > -1;
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    getCharCodeFromEvent(event) {
        event = event || window.event;
        return (typeof event.which === "undefined") ? event.keyCode : event.which;
    }

    isCharNumeric(charStr) {
        return !!/\d/.test(charStr);
    }

    isKeyPressedNumeric(event) {
        const charCode = this.getCharCodeFromEvent(event);
        const charStr = event.key ? event.key : String.fromCharCode(charCode);
        return this.isCharNumeric(charStr);
    }

    deleteOrBackspace(event) {
        return [KEY_DELETE, KEY_BACKSPACE].indexOf(event.keyCode) > -1;
    }

    render() {
        return (
            <input ref="input"
                value={this.props.value || ""}
                onChange={this.props.onChange}
                onKeyDown={this.props.onKeyDown}
                style={{ width: "50px" }}
                pattern="[0-9]*"
                inputMode="numeric"
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/SalesOrder/NumericSOEditor.js